import { workspaceOwnerUsersPermissions, adminUsersPermissions, collaboratorUsersPermissions }
	from './permissions/usersPermissions';
import { workspaceOwnerSubscriptionPermissions, adminSubscriptionPermissions, collaboratorSubscriptionPermissions }
	from './permissions/subscriptionPermissions';

export class WorkspaceRolePermissions {
	constructor(
		usersPermissions,
		subscriptionPermissions
	) {
		this.usersPermissions = usersPermissions;
		this.subscriptionPermissions = subscriptionPermissions;
	}

	/**
	 * @param {bool} condition Accepts any boolean. Usually a selector of the permission
	 * @param {*} componentToShow
	 * @example RolePermissions.renderIfUserIsAllowed( getUserCanUploadAssets, <button /> )
	 */
	static renderIfUserIsAllowed( condition, componentToShow ) {
		return condition
			? componentToShow
			: null;
	}

	/**
	 * @param {'edit'|'add'|'destroy'|'archive'|'view'|'seeVersions'} permit
	 * @param {'projects'|'assets'|'markups'|'tasks'|'comments'|'users'} entity
	 * @example currentUserCan( 'edit', 'projects' ) // => true
	 */

	currentUserCan( permit, entity ) {
		const permission = `${entity}Permissions`;
		if ( !this[ permission ] || this[ permission ][ permit ] === undefined ) {
			throw new Error( 'The requested permission does not exist' );
		}
		return this[ permission ][ permit ];
	}
}

export const ownerRolePermissions = new WorkspaceRolePermissions(
	workspaceOwnerUsersPermissions,
	workspaceOwnerSubscriptionPermissions
);

export const adminRolePermissions = new WorkspaceRolePermissions(
	adminUsersPermissions,
	adminSubscriptionPermissions
);

export const collaboratorRolePermissions = new WorkspaceRolePermissions(
	collaboratorUsersPermissions,
	collaboratorSubscriptionPermissions
);
